import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./cropImageHelper";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Plus, X, Upload, Save, ArrowLeft, Library } from "lucide-react";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../components/ui/form";
import { Link } from "react-router-dom";
// Icon options for issue types
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
function AddProduct() {
  const [issueTypes, setIssueTypes] = useState([]);
  const [selectedProductTypes, setSelectedProductTypes] = useState([]);

  const [value, setValue] = React.useState("");

  const predefinedProductTypes = [
    { id: "hairregrowth", name: "Hair Regrowth", category: "Electronics" },
    { id: "skincare", name: "Skin Care", category: "Electronics" },
    { id: "sexualhealth", name: "Sexual Health", category: "Electronics" },
    { id: "weightloss", name: "Weight Loss", category: "Home" },
    { id: "mentalhealth", name: "Mental Health", category: "Electronics" },
  ];

  const form = useForm({});

  const [imageSrc, setImageSrc] = useState(null); // holds selected image url
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);
    }
  };

  const readFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result));
      reader.readAsDataURL(file);
    });
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedImage(croppedImage);
      // You can upload croppedImage (a blob URL or base64) to server here
    } catch (e) {
      console.error(e);
    }
  }, [imageSrc, croppedAreaPixels]);
  return (
    <>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Link to="/adminproducts">
            <Button variant="outline" size="sm">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Add Product</h1>
            <p className="text-gray-600">
              Create a new product by entering its details, pricing,
              description.
            </p>
          </div>
        </div>

        <Form {...form}>
          <form className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Basic Information */}
              <Card>
                <CardHeader>
                  <CardTitle>Basic Information</CardTitle>
                  <CardDescription>
                    Core details for the product
                  </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="terms-upload">Upload Product Image</Label>
                    <div className="gap-2">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={onFileChange}
                      />
                      {imageSrc && (
                        <div
                          style={{
                            position: "relative",
                            width: 200,
                            height: 300,
                          }}
                        >
                          <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                          />
                          <Button onClick={showCroppedImage} className="mt-2">
                            Crop
                          </Button>
                        </div>
                      )}
                      {croppedImage && (
                        <img
                          src={croppedImage}
                          alt="Cropped"
                          style={{
                            marginTop: 20,
                            width: 200,
                            height: 300,
                            borderRadius: "50%",
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <FormField
                    name="planTitle"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Product Name</FormLabel>
                        <FormControl>
                          <Input placeholder="e.g., Minoxidil / Finasteride / Ketoconazole" />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    name="planTitle"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Sku Code</FormLabel>
                        <FormControl>
                          <Input placeholder="e.g., SF09281" />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />

                  <FormField
                    name="planDescription"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Product Description</FormLabel>
                        <FormControl>
                          <Textarea
                            placeholder="Describe what this Product used for..."
                            rows={3}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <div>
                    <label className="text-sm font-medium text-gray-900 block mb-2">
                      Product Categories
                    </label>
                    <div className="space-y-3">
                      <div className="grid grid-cols-2 gap-3">
                        {predefinedProductTypes.map((productType) => (
                          <div
                            key={productType.id}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="checkbox"
                              id={productType.id}
                              checked={selectedProductTypes.some(
                                (pt) => pt.id === productType.id
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedProductTypes([
                                    ...selectedProductTypes,
                                    productType,
                                  ]);
                                } else {
                                  setSelectedProductTypes(
                                    selectedProductTypes.filter(
                                      (pt) => pt.id !== productType.id
                                    )
                                  );
                                }
                              }}
                              className="rounded border-gray-300 text-accent focus:ring-accent"
                            />
                            <label
                              htmlFor={productType.id}
                              className="text-sm text-gray-700"
                            >
                              {productType.name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <FormField
                      name="planTitle"
                      render={({ field }) => (
                        <FormItem className="flex-1">
                          <FormLabel>Regular price($)</FormLabel>
                          <FormControl>
                            <Input placeholder="$" />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <FormField
                      name="description"
                      render={({ field }) => (
                        <FormItem className="flex-1">
                          <FormLabel>Promotional price($)</FormLabel>
                          <FormControl>
                            <Input placeholder="$" />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <FormField
                      name="description"
                      render={({ field }) => (
                        <FormItem className="flex-1">
                          <FormLabel>Currency</FormLabel>
                          <FormControl>
                            <Select value="USD">
                              <SelectTrigger>
                                <SelectValue placeholder="Select currency" />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="USD">USD</SelectItem>
                                <SelectItem value="EUR">EUR</SelectItem>
                                <SelectItem value="INR">INR</SelectItem>
                                {/* Add more currencies as needed */}
                              </SelectContent>
                            </Select>
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </div>
                  <FormField
                    name="planDescription"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Tax rate(%)</FormLabel>
                        <FormControl>
                          <Input placeholder="%" />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </CardContent>
              </Card>

              {/* Issue Types Configuration */}
              <Card>
                <CardHeader>
                  <CardTitle>Product Details</CardTitle>
                  <CardDescription>
                    Comprehensive information about how to use, terms &
                    conditions, product details.
                  </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <FormField
                    name="termsAndConditions"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Product Details</FormLabel>
                        <FormControl>
                          <ReactQuill value={value} onChange={setValue} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    name="termsAndConditions"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>How to Use</FormLabel>
                        <FormControl>
                          <ReactQuill value={value} onChange={setValue} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />

                  <FormField
                    name="termsAndConditions"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Ingredients</FormLabel>
                        <FormControl>
                          <ReactQuill value={value} onChange={setValue} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </CardContent>
              </Card>
            </div>

            <div className="flex justify-end gap-4">
              <Button type="button" variant="outline">
                Cancel
              </Button>
              <Button type="submit">
                <Save className="h-4 w-4 mr-2" />
                Add Product
              </Button>
            </div>
          </form>
        </Form>
      </div>
    </>
  );
}
export default AddProduct;
